import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=7687d299"
import script from "./help-center.vue?vue&type=script&lang=ts"
export * from "./help-center.vue?vue&type=script&lang=ts"
import style0 from "./help-center.vue?vue&type=style&index=0&id=7687d299&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports